import {
  DEFINITIONS as PLUGIN_DEFINITIONS,
  H2,
  H3,
  H4,
} from '@xingternal/content-editor-plugin-heading';

import {
  HEADING2_TYPENAME,
  HEADING3_TYPENAME,
  HEADING4_TYPENAME,
  SERIALIZATION,
  HEADING2_FIELDNAME,
  HEADING3_FIELDNAME,
  HEADING4_FIELDNAME,
} from '../constants';

const getHeadingLevel = ({ node: { __typename } }) => {
  switch (__typename) {
    case HEADING2_TYPENAME:
      return H2;
    case HEADING3_TYPENAME:
      return H3;
    case HEADING4_TYPENAME:
      return H4;
  }
};

const getTypename = ({ level }) => {
  switch (level) {
    case H2:
      return HEADING2_FIELDNAME;
    case H3:
      return HEADING3_FIELDNAME;
    case H4:
      return HEADING4_FIELDNAME;
  }
};

const getTypenameDeserialize = ({ level }) => {
  switch (level) {
    case H2:
      return HEADING2_TYPENAME;
    case H3:
      return HEADING3_TYPENAME;
    case H4:
      return HEADING4_TYPENAME;
  }
};

const DEFINITIONS = ({ level }) => ({
  ...PLUGIN_DEFINITIONS,
  __typename: getTypename({ level }),
});

const DESERIALIZATION_DEFINITIONS = ({ level }) => ({
  ...PLUGIN_DEFINITIONS,
  __typename: getTypenameDeserialize({ level }),
});

const headingSerializer = ({
  createBlock,
  direction,
  extractChildren,
  matchBlock,
  node,
  normalizeInlinesChildren,
  serializeNodes,
}) => {
  const level =
    direction === SERIALIZATION
      ? node.data && node.data.level
      : getHeadingLevel({ node });
  if (matchBlock({ node, match: DEFINITIONS({ level }) })) {
    let children = extractChildren({ node });
    children = normalizeInlinesChildren({ children });
    let childrenNodes = serializeNodes(children);
    return createBlock({
      children: childrenNodes,
      data: { level },
      definitions: DEFINITIONS({ level }),
      node,
    });
  }
  if (matchBlock({ node, match: DESERIALIZATION_DEFINITIONS({ level }) })) {
    let children = extractChildren({ node });
    children = normalizeInlinesChildren({ children });
    let childrenNodes = serializeNodes(children);

    return createBlock({
      children: childrenNodes[0],
      data: { level },
      definitions: DESERIALIZATION_DEFINITIONS({ level }),
      node,
    });
  }
};

export { headingSerializer };
